import React from 'react';
import getFilterParamsToType from 'apollo/userRecentSearch/helpers/getFilterParamsToType';
import { useApiFiltersContext } from 'contexts/ApiFiltersContext/ApiFiltersContext';
import { FiltersParams } from 'types/params';
import { RoutePaths } from 'types/enums';
import { FiltersContainer } from './style';
import { FilterList } from './components/FilterList';
import { FilterSkeleton } from './components/FilterSkeleton';

const useListFilters = ({ filterParams }: { filterParams: FiltersParams }) => {
    const filterType = getFilterParamsToType(filterParams)?.toLowerCase();
    const { apiFilters } = useApiFiltersContext();

    const isSupportedFilterType =
        filterType === 'instruments' ||
        filterType === 'genres' ||
        filterType === 'sfxs';

    const filters = isSupportedFilterType && apiFilters[filterType];

    const showSkeleton = !filters || filters.length === 0;

    return { showSkeleton, filters };
};

export const ListFilters = ({
    filterParams,
    path,
}: {
    filterParams: FiltersParams;
    path: RoutePaths;
}) => {
    const { showSkeleton, filters } = useListFilters({ filterParams });

    return (
        <FiltersContainer>
            {showSkeleton && <FilterSkeleton />}
            {!showSkeleton && !!filters && (
                <FilterList path={path} filters={filters} />
            )}
        </FiltersContainer>
    );
};
